<template>
  <el-dialog class="default-dialog" :custom-class="customClass" :close-on-press-escape="false" :modal-append-to-body="false"
              @close="headerClose" :show-close="false" :close-on-click-modal="false" :visible.sync="dialogVisible" :width="width"
              :center="center">
    <template v-if="showTitle">
      <div slot="title" class="dialog-header" v-html="title"></div>
    </template>
    <div v-html="content"></div>
    <span slot="footer" class="dialog-footer center" :class="{'no-border': noBorder}" v-if="showFooter">
        <template v-if="!buttonReverse">
            <el-button class="yBtn" :type="yButtonType" :disabled="btnLoading" :loading="btnLoading" v-if="!yButtonHidden" @click="closeDialog">{{yButtonText}}</el-button>
            <el-button class="nBtn" :type="nButtonType" v-if="!nButtonHidden && ['confirm', 'confirm.delete'].includes(type)" @click="dialogVisible = false">{{nButtonText}}</el-button>
        </template>
        <template v-else>
            <el-button class="nBtn" :type="nButtonType" v-if="!nButtonHidden && ['confirm', 'confirm.delete'].includes(type)" @click="dialogVisible = false">{{nButtonText}}</el-button>
            <el-button class="yBtn" :type="yButtonType" :disabled="btnLoading" :loading="btnLoading" v-if="!yButtonHidden" @click="closeDialog">{{yButtonText}}</el-button>
        </template>
    </span>
    <span slot="footer" class="dialog-footer center" :class="{'no-border': noBorder}" v-else>
        <el-button class="alertBtn" :type="yButtonType" :disabled="btnLoading" :loading="btnLoading" @click="closeDialog">{{yButtonText}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
/* eslint-disable */
export default {
  name: 'AlertDialog',
  data: function () {
    return {
      showTitle: true,
      showFooter: true,
      dialogVisible: false,
      center: false,
      noBorder: false,
      width: '600px',
      title: '温馨提示',
      type: 'alert',
      content: '',
      customClass: '',
      nButtonText: '取 消',
      nButtonType: 'primary',
      nButtonHidden: false,
      yButtonText: '确 定',
      yButtonType: 'primary',
      yButtonHidden: false,
      buttonReverse: false,
      yCallback: null,
      btnLoading: false,
      hCallback: null,
      isPromise: false,
    }
  },
  updated(){
    let target = document.querySelector('.test-icon i');
    if(target) {
      this.$loading({
        lock: true,
        target: '.test-icon i'
      });
    }
  }
  ,
  created: function () {
    let me = this;

    function callback(params) {
      let _start = +new Date();
      me.dialogVisible = true;
      me.showFooter = params.showFooter !== undefined?params.showFooter:true;
      me.showTitle = params.showTitle !== undefined?params.showTitle:true;
      me.center = params.align;
      me.noBorder = params.noBorder || me.noBorder;
      let w = params.width;
      if(w) {
        if(w.indexOf('px')>-1||w.indexOf('%')>-1) {
          me.width = params.width;
        } else {
          if(me.width != Number.parseFloat(w)) {
            // me.width = params.width;
          } else {
            me.width = params.width + 'px';
          }
        }
      }
      me.content = params.content;
      me.title = params.title || '温馨提示';
      me.yCallback = params.yCallback || null;
      me.hCallback = params.hCallback || null;
      me.buttonReverse = params.buttonReverse || false;
      me.isPromise = params.isPromise || false;
      // 确定按钮
      me.yButtonText = params.yButtonText || '确 定';
      me.yButtonType = params.yButtonType || 'primary';
      me.yButtonHidden = params.yButtonHidden || false;
      me.btnLoading = false;
      me.btnLoadingPre = params.btnLoading || false;
      // 取消按钮
      me.nButtonText = params.nButtonText || '取 消';
      me.nButtonType = params.nButtonType || 'primary';
      me.nButtonHidden = params.nButtonHidden || false;
      // me.modal = params.modal!==undefined?params.modal:true; 
      me.customClass = (params.customClass ? params.customClass : '')+(['confirm', 'confirm.delete'].includes(me.type)?' confirm': '');
      if(me.type==='confirm.delete') {
        me.customClass = 'simple-dialog '+me.customClass;
        me.showTitle = false;
        me.noBorder = true;
        if(params.watch || params.watch === false) {
          me.watch = params.watch || false;
        }
        me.center = params.align !== undefined ? params.align : true;
        if(!w) {
          me.width = '400px';
        }
        me.yButtonText = params.yButtonText || '确定删除';
        me.nButtonText = params.nButtonText || '取消操作';
        me.yButtonType = params.yButtonType || 'default'
      }
      if(me.type == 'confirm') {
        me.autoClose = params.autoClose || false;
        me.watch = params.watch || false;
        me.timeout = params.timeout!=null?params.timeout:(params.watch?1000:null); // 关闭弹窗timer
        me.delay = params.delay!=null?params.delay:(params.watch?1000:null);// 整个请求的最长时间
        me.delayAfter = params.delayAfter!=null?params.delayAfter:(params.watch?800:null); // 请求回来后执行callback前间隔
        me.finishCb = params.finishCb||null;
        // me.customClass += 'loading';
        if(me.timeout!= null && !me.watch && me.autoClose) {
          setTimeout(() => {
            me.closeDialog()
          }, me.timeout);
        }
        if(me.watch) {
          let old = params.content;
          let old2 = params.customClass;
          me.customClass = 'simple-dialog '+(params.loading?'loading ':'')+((params.customClass ? params.customClass : '')+(['confirm', 'confirm.delete'].includes(me.type)?' confirm': ''));
          Object.defineProperty(params, 'content', {
            enumerable: false,
            configurable: true,
            set: function(val) {
              var o = old;
              old = val;
              let diff = me.delay - (+new Date() - _start);
              // 若未到达固定时长，则等待（防止请求过快导致的闪现问题）
              if(diff > 0) {
                setTimeout(() => {
                  me.content = val;
                  me.showFooter = params.showFooter||false;
                  me.customClass = 'simple-dialog '+(params.loading ? params.loading : '')+(['confirm', 'confirm.delete'].includes(me.type)?' confirm': '');;
                  me.nButtonHidden = params.nButtonHidden||false; 
                  // 若有请求返回后的业务回调，则执行业务，执行完毕后回来调用本地的afterFn
                  if(me.finishCb) {
                    me.finishCb(val,o,params,me.afterFn);
                  } else {
                    me.autoClose && me.timerClose();
                  }
                }, diff)
              } else {
                me.content = val;
                me.customClass = 'simple-dialog '+(params.loading ? params.loading : '')+(['confirm', 'confirm.delete'].includes(me.type)?' confirm': '');;
                if(me.finishCb) {
                  me.finishCb(val,o,params,me.autoClose?me.timerClose:null);
                } else {
                  me.autoClose && me.timerClose();
                }
              }
            },
            get:function(){
              return old;
            }
          })
        }
      }
      if(me.type==='alert') {
        me.customClass = 'simple-dialog '+me.customClass;
        me.showTitle = false;
        me.showFooter = false;
        me.noBorder = true;
        me.autoClose = params.autoClose || false;
        me.watch = params.watch || false;
        me.timeout = params.timeout!=null?params.timeout:(params.watch?1000:null); // 关闭弹窗timer
        me.delay = params.delay!=null?params.delay:(params.watch?1000:null);// 整个请求的最长时间
        me.delayAfter = params.delayAfter!=null?params.delayAfter:(params.watch?800:null); // 请求回来后执行callback前间隔
        me.center = params.align !== undefined ? params.align : true;
        me.finishCb = params.finishCb||null;
        if(!w) {
          me.width = '400px';
        }
        if(me.timeout!= null && !me.watch && me.autoClose) {
          setTimeout(() => {
            me.closeDialog()
          }, me.timeout);
        }
        if(me.watch) {
          let old = params.content;
          let old2 = params.customClass;
          me.customClass = 'simple-dialog '+((params.customClass ? params.customClass : '')+(['confirm', 'confirm.delete'].includes(me.type)?' confirm': ''));
          Object.defineProperty(params, 'customClass', {
            enumerable: false,
            configurable: true,
            set: function(val) {
              var o = old2;
              old2 = val;
              me.customClass = (val ? val : '')+(['confirm', 'confirm.delete'].includes(me.type)?' confirm': '');;
            },
            get:function(){
              return old2;
            }
          });
          Object.defineProperty(params, 'content', {
            enumerable: false,
            configurable: true,
            set: function(val) {
              var o = old;
              old = val;
              let diff = me.delay - (+new Date() - _start);
              if(diff>0) {
                setTimeout(() => {
                  me.content = val;
                  me.showFooter = params.showFooter||false;
                  me.nButtonHidden = params.nButtonHidden||false; 
                  if(me.finishCb) {
                    me.finishCb(val,o,params,me.afterFn);
                  } else {
                    me.autoClose && me.timerClose();
                  }
                }, diff)
              } else {
                me.content = val;
                if(me.finishCb) {
                  me.finishCb(val,o,params,me.autoClose?me.timerClose:null);
                } else {
                  me.autoClose && me.timerClose();
                }
              }
            },
            get:function(){
              return old;
            }
          })
        }
      }
    }

    this.$parent.$on('show.alert', function () {
      me.type = 'alert';
      callback.apply(this, arguments);
      // setTimeout(() => {
      //   me.closeDialog()
      // }, 1500);
    });
    this.$parent.$on('show.confirm', function () {
      me.type = 'confirm';
      callback.apply(this, arguments);
    });
    this.$parent.$on('show.confirm.delete', function () {
      me.type = 'confirm.delete';
      callback.apply(this, arguments);
    });
    this.$parent.$on('show.confirm.close', function () {
      me.dialogVisible = false;
    });
  },
  methods: {
    async afterFn(cb) {
      if(this.autoClose) {
        await this.timerClose();
      }
      setTimeout(() => {
        cb && cb();
      }, this.delayAfter)
    },
    timerClose(fn) {
      return new Promise((resolve, reject) => {
        if(this.timeout != null) {
          let me = this;
          setTimeout(() => {
            me.dialogVisible = false;
            fn && fn();
            resolve();
          }, this.timeout);
        } else {
          fn && fn();
          resolve()
        }
      })
    },
    headerClose: function () {
      this.hCallback && this.hCallback();
      // if(this.watch) {
      //   this.closeDialog();
      // }
      this.dialogVisible=false;
    },
    closeDialog: function () {
      let me = this;
      if(this.type == 'alert'){
        return this.dialogVisible = false;
      }
      if(this.yCallback) {
        this.btnLoading = this.btnLoadingPre;
        // 每次检查都会执行，故传参1，在callback中校验不执行后续
        if(me.isPromise) {
          me.yCallback().then((isForbidden) => {
            this.btnLoading = false;
            this.dialogVisible = !!isForbidden;
          }).catch(err => {
            this.btnLoading = false;
            this.dialogVisible = false;
          })
        } else {
          this.yCallback && this.yCallback();
          this.btnLoading = false;
          this.dialogVisible = false;
        }
      }
    }
  },
  destroyed: function () {
    let $parent = this.$parent;
    $parent.$off('show.alert');
    $parent.$off('show.confirm');
  },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    /deep/.el-dialog{
      width: 400px;
      height: 160px;
      padding: 0;
      border-radius: 0;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      margin: 0 !important;
      .el-dialog__header{
        text-align: center;
      }
      .el-dialog__body{
        text-align: center;
        padding-top: 18px;
        color: #474747;
        padding-bottom: 0;
        span{
          font-size: 16px;
          font-weight: 500;
        }
        p{
          font-size: 14px;
          margin-top: 26px;
          margin-bottom: 20px;
        }
        .descD{
          margin: 10px 0;
        }
      }
      .el-dialog__footer{
        .dialog-footer{
          padding: 0;
          .el-button{
            width: 66px;
            height: 32px;
            border: 0;
            border-radius:0;
          }
          .yBtn{
            color: #2F8EFF;
            background: rgba(70, 157, 255, 0.15);
            &:hover{
              background: rgba(70, 157, 255, 0.3);
            }
          }
          .nBtn{
            background: rgba(70, 157, 255, 1);
            &:hover{
              background: rgba(70, 157, 255, 0.85);
            }
          }
          .alertBtn{
            width: 100px;
            height: 32px;
            background: #469DFF;
            &:hover{
              background: #469DFF;
            }
          }
        }
      }
    }
    .default-dialog {
        line-height: 24px;
    }

    .dialog-footer {
        text-align: center;
    }
    p {
      margin: 0;
      padding: 0; 
      margin-block-start: 0;
      margin-block-end: 0;
    }

</style>


// WEBPACK FOOTER //
// src/components/AlertDialogNew.vue